<!--  -->
<template>
  <div class="table_box">
    <div class="add_plate">
      <el-button type="success" icon="el-icon-plus" @click="addplatform">添加平台</el-button>
    </div>
    <el-table
      :data="tableData"
      border
      style="width: 100%"
      max-height="700"
    >
      <el-table-column
        prop="id"
        label="ID"
        width="180"
        align="center"
      />
      <el-table-column
        prop="name"
        label="平台名称"
        width="180"
        align="center"
      />
      <el-table-column
        prop="address"
        label="操作"
        align="center"
      >
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="platformaccount(scope.row)">平台账号</el-button>
          <el-button type="warning" size="mini" @click="edit(scope.row)">编辑</el-button>
          <el-button type="success" size="mini" @click="open(scope.row.id)">更新小说</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-drawer
      :title="title"
      :visible.sync="drawer"
      :direction="direction"
      :destroy-on-close="true"
      size="53%"
    >
      <platedrawer ref="platedrawerview" />
    </el-drawer>
    <el-dialog
      title="添加平台"
      :visible.sync="addplatedialog"
      :destroy-on-close="true"
      width="30%"
    >
      <addplate ref="addplateview" @updataclose="updataclose" />
    </el-dialog>
    <el-dialog
      title="更新小说"
      :visible.sync="updataDialog"
      :destroy-on-close="true"
      width="15%"
      @closed="keyword = null"
    >
      <div v-if="updataDialog" class="dialog_box">
        <el-input v-model="keyword" placeholder="请输入平台id或者名称" style="margin-bottom:20px" />
        <el-button style="width: 100px" type="success" size="mini" @click="updatata">更新</el-button>
      </div>
    </el-dialog>
  </div>

</template>

<script>
import { platformlist, platformlistaewr } from '@/api/sourceMaterial.js'
import platedrawer from './components/platedrawer.vue'
import addplate from './components/addplate.vue'
export default {
  components: { platedrawer, addplate },
  data() {
    return {
      title: '',
      tableData: [],
      drawer: false,
      direction: 'rtl',
      addplatedialog: false,
      updataDialog: false,
      keyword: null,
      platformId: null
    }
  },
  created() {
    this.getlist()
  },
  mounted() {

  },
  methods: {
    async getlist() {
      const data = await platformlist()
      this.tableData = data.data
      console.log('data', data)
    },
    addplatform() {
      this.addplatedialog = true
    },
    platformaccount(item) {
      this.drawer = true
      this.title = item.name
      this.$nextTick(() => {
        this.$refs.platedrawerview.send(item)
      })
    },
    edit(item) {
      this.addplatedialog = true
      this.$nextTick(() => {
        this.$refs.addplateview.sendedit(item)
      })
    },
    open(id) {
      this.platformId = id
      this.updataDialog = true
    },
    updataclose() {
      this.addplatedialog = false
      this.getlist()
    },
    async updatata() {
      const data = await platformlistaewr({
        platform_id: this.platformId,
        keyword: this.keyword ? this.keyword : ''
      })
      this.$message({
        message: '更新成功',
        type: 'success'
      })
      this.keyword = null
      this.updataDialog = false
      console.log(data)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.table_box{
  padding: 20px;
}
.add_plate{
  text-align: right;
  margin-bottom: 20px;
}
.dialog_box{
display: flex;
flex-direction: column;
}
</style>
